export const fileSizeReadable = (bytes: number) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024; // Size of a kilobyte
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k)); // Determine the index for the size array

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]; // Format the size
}